module.exports = __webpack_public_path__ + "img/meiyan-en.c9e0a2f6.webp";